import { createContext, useContext } from 'react';

type NavigateToFunctionFn = (functionId: string) => void;

export const NavigateToFunctionContext = createContext<NavigateToFunctionFn | null>(null);

export const NavigateToFunctionContextProvider = NavigateToFunctionContext.Provider;

export function useNavigateToFunction() {
    return useContext(NavigateToFunctionContext);
}
